<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import buildingIllustrationUrl from '@/assets/images/dreama-building.webp'
import { APP_ROUTE_DEFINITIONS } from '@/constants/routes'

const route = useRoute()

const routeDefinition = computed(() =>
  APP_ROUTE_DEFINITIONS.find((definition) => definition.path === route.path),
)
const sectionTitle = computed(
  () => routeDefinition.value?.label || String(route.meta.section ?? route.meta.title ?? '功能'),
)
const placeholderMessage = computed(() => `${sectionTitle.value}页构建中，敬请期待`)
</script>

<template>
  <section class="placeholder-screen">
    <section class="placeholder-content" :aria-label="placeholderMessage">
      <div class="placeholder-illustration" aria-hidden="true">
        <img class="placeholder-illustration__image" :src="buildingIllustrationUrl" alt="" />
      </div>
      <p class="placeholder-message">{{ placeholderMessage }}</p>
    </section>
  </section>
</template>

<style scoped>
.placeholder-screen {
  display: flex;
  min-height: calc(100vh - 16px);
  align-items: center;
  justify-content: center;
  background: var(--app-bg);
}

.placeholder-content {
  display: flex;
  width: min(100%, 600px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

.placeholder-illustration {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
}

.placeholder-illustration__image {
  position: absolute;
  top: -16.94%;
  left: 50%;
  width: auto;
  height: 134.16%;
  max-width: none;
  object-fit: cover;
  transform: translateX(-50%);
  pointer-events: none;
  user-select: none;
}

.placeholder-message {
  margin: 0;
  color: var(--app-text-main);
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
}
</style>
